<p-panel header="Authorization Details">
  @if (!utilitiesLoading) {
    <form [formGroup]="form">
      <div class="mb-4">
        <span class="font-semibold">Please enter the details for the authorization request:</span>
      </div>
      <div class="grid grid-cols-12 gap-4 p-fluid p-form-widget p-form-aligned">
        <div class="col-span-12 md:col-span-6">
          <div class="field">
            <label class="field-required">Type of Authorization:</label>
            <div class="p-field-value">
              <p-select
                placeholder="Select"
                formControlName="facilityType"
                data-test-id="auth-type-dropdown"
                [options]="references.facilityType"
                >
              </p-select>
              <errors-messages [control]="form.get('facilityType')"></errors-messages>
            </div>
          </div>
          <div class="field" [class.p-disabled]="form.get('clinicalCategories').disabled">
            <label class="field-required">Clinical Category:</label>
            <div class="p-field-value">
              <p-select
                placeholder="Select"
                formControlName="clinicalCategories"
                data-test-id="clinical-categories-dropdown"
                [options]="references.clinicalCategories"
                >
              </p-select>
              <errors-messages [control]="form.get('clinicalCategories')"></errors-messages>
            </div>
          </div>
          <div class="field" [class.p-disabled]="form.get('referralSource').disabled">
            <label class="field-required">Acute Referral Source:</label>
            <div class="p-field-value">
              <p-select
                placeholder="Select"
                formControlName="referralSource"
                data-test-id="refferal-source-dropdown"
                [options]="references.referralSource"
                >
              </p-select>
              <errors-messages [control]="form.get('referralSource')"></errors-messages>
              @if (!isInternalFlow) {
                <div class="mt-4">
                  <p-message
                    class="instruction-message secondary-message"
                    severity="info"
                    [text]="referralSourceMsg"
                  ></p-message>
                </div>
              }
            </div>
          </div>
          <div class="field" [class.p-disabled]="form.get('referralFacilityNPI').disabled">
            <label [class.field-required]="!form.get('unknownReferralFacilityNPI').value">Acute (Prior) Referral Facility NPI:</label>
            <div class="p-field-value">
              <p-inputMask
                data-test-id="facility-npi-input"
                formControlName="referralFacilityNPI"
                mask="9999999999"
                slotChar=""
                [autoClear]="false"
              />
                <errors-messages [control]="form.get('referralFacilityNPI')"></errors-messages>
                <div class="mt-4">
                  <p-message
                    class="instruction-message secondary-message"
                    severity="info"
                    [text]="referralFacilityNPIMsg"
                  ></p-message>
                </div>
              </div>
            </div>
            <div class="field" [class.p-disabled]="form.get('unknownReferralFacilityNPI').disabled">
              <label>Unknown Acute (Prior) Referral Facility NPI:</label>
              <div class="p-field-value flex">
                <p-checkbox
                  formControlName="unknownReferralFacilityNPI"
                  data-test-id="unknown-npi-checkbox"
                  [binary]="true"
                ></p-checkbox>
              </div>
            </div>
            <div class="field" [class.p-disabled]="form.get('referralFacilityName').disabled">
              <label [class.field-required]="!form.get('unknownReferralFacility').value">Acute (Prior) Referral Facility Name:</label>
              <div class="p-field-value">
                <input
                  pInputText
                  type="text"
                  formControlName="referralFacilityName"
                  data-test-id="facility-name-input"
                  />
                  <errors-messages [control]="form.get('referralFacilityName')"></errors-messages>
                  <div class="mt-4">
                    <p-message
                      class="instruction-message secondary-message"
                      severity="info"
                      [text]="referralFacilityNameMsg"
                    ></p-message>
                  </div>
                </div>
              </div>
              <div class="field" [class.p-disabled]="form.get('unknownReferralFacility').disabled">
                <label>Unknown Acute (Prior) Referral Facility Name:</label>
                <div class="p-field-value flex">
                  <p-checkbox
                    formControlName="unknownReferralFacility"
                    data-test-id="unknown-facility-name-checkbox"
                    [binary]="true"
                  ></p-checkbox>
                </div>
              </div>
              <div
                *accessView="['PACIMAuthorization.ReferralSourceContactName.Read']"
                class="field"
                [class.p-disabled]="form.get('referralSourceName').disabled"
                >
                <label [class.field-required]="!isInternalFlow">
                  Acute (Prior) Hospital Direct Contact Name:
                </label>
                <div class="p-field-value">
                  <input
                    pInputText
                    trimInputValue
                    type="text"
                    formControlName="referralSourceName"
                    data-test-id="ref-source-name-input"
                    />
                    <errors-messages [control]="form.get('referralSourceName')">
                    </errors-messages>
                    <div class="mt-4">
                      <p-message
                        class="instruction-message secondary-message"
                        severity="info"
                        [text]="referralSourceNameMsg"
                      ></p-message>
                    </div>
                  </div>
                </div>
                <div
                  *accessView="['PACIMAuthorization.ReferralSourcePhone.Read']"
                  class="field"
                  [class.p-disabled]="form.get('referralSourcePhone').disabled"
                  >
                  <label [class.field-required]="!isInternalFlow">Acute (Prior) Hospital Direct Phone Number:</label>
                  <div class="p-field-value">
                    <p-input-mask
                      class="w-full"
                      mask="(999) 999-9999"
                      formControlName="referralSourcePhone"
                      data-test-id="ref-source-phone-input"
                      [unmask]="true"
                      [autoClear]="false"
                      >
                    </p-input-mask>
                    <errors-messages [control]="form.get('referralSourcePhone')"></errors-messages>
                    <div class="mt-4">
                      <p-message
                        class="instruction-message"
                        severity="warn"
                        [text]="referralSourcePhoneMsg"
                      ></p-message>
                    </div>
                  </div>
                </div>
                <div
                  *accessView="['PACIMAuthorization.ReferralSourceFax.Read']"
                  class="field"
                  [class.p-disabled]="form.get('referralSourceFax').disabled"
                  >
                  <label [class.field-required]="!isInternalFlow">Acute (Prior) Hospital Direct Fax Number:</label>
                  <div class="p-field-value">
                    <p-input-mask
                      class="w-full"
                      mask="(999) 999-9999"
                      formControlName="referralSourceFax"
                      data-test-id="ref-source-fax-input"
                      [unmask]="true"
                      [autoClear]="false"
                      >
                    </p-input-mask>
                    <errors-messages [control]="form.get('referralSourceFax')"></errors-messages>
                  </div>
                </div>
              </div>
              <div class="col-span-12 md:col-span-6">
                @if (isInternalFlow) {
                  <div class="field" [class.p-disabled]="form.get('requestReceivedDate').disabled">
                    <label [class]="{ 'field-required' : !faxReceivedDateTime }">Date/Time Request Received:</label>
                    @if (!faxReceivedDateTime) {
                      <div class="p-field-value">
                        <p-date-picker
                          formControlName="requestReceivedDate"
                          appendTo="body"
                          hourFormat="12"
                          placeholder="mm/dd/yyyy hh:mm:ss"
                          [showTime]="true"
                          data-test-id="request-received-calendar"
                          [showSeconds]="true"
                          [readonlyInput]="true"
                          [showIcon]="true"
                          [maxDate]="currentDate"
                          (onShow)="showRequestReceivedCalendar()"
                          >
                        </p-date-picker>
                        <errors-messages [control]="form.get('requestReceivedDate')"></errors-messages>
                      </div>
                    } @else {
                      <div class="p-field-value flex items-center">
                        {{form.get('requestReceivedDate').value | date: 'MM/dd/yyyy hh:mm:ss a'}}
                      </div>
                    }
                  </div>
                }
                <div class="field" [class.p-disabled]="form.get('anticipatedAdmitDate').disabled">
                  <label class="field-required">Anticipated Admit Date:</label>
                  <div class="p-field-value">
                    <p-date-picker
                      formControlName="anticipatedAdmitDate"
                      placeholder="mm/dd/yyyy"
                      appendTo="body"
                      data-test-id="admit-date-calendar"
                      [readonlyInput]="true"
                      [showIcon]="true"
                      [maxDate]="admitDateFutureCap"
                      (onSelect)="onAnticipatedDateChange()"
                      >
                    </p-date-picker>
                    <errors-messages [control]="form.get('anticipatedAdmitDate')"></errors-messages>
                  </div>
                </div>
                @if (form.get('memberAdmitted'); as memberAdmittedControl) {
                  <div
                    class="field"
                    [class.mb-3]="memberAdmittedControl.value">
                    <label class="field-required">
                      Is the member currently admitted to a {{ form.get('facilityType').value?.description || 'facility' }}?
                    </label>
                    <div class="p-field-value">
                      <div class="flex gap-4">
                        <div class="flex items-center">
                          <p-radio-button
                            name="memberAdmitted"
                            formControlName="memberAdmitted"
                            inputId="memberAdmitted_yes"
                            class="mr-2"
                            data-test-id="member-admitted-radioButton"
                            [value]="true"
                            (onClick)="onMemberAdmittedChange()"
                          />
                          <label for="memberAdmitted_yes" class="ml-2">Yes</label>
                        </div>
                        <div class="flex items-center">
                          <p-radio-button
                            name="memberAdmitted"
                            formControlName="memberAdmitted"
                            inputId="memberAdmitted_no"
                            data-test-id="member-not-admitted-radioButton"
                            [value]="false"
                            (onClick)="onMemberAdmittedChange()"
                          />
                          <label for="memberAdmitted_no" class="ml-2">No</label>
                        </div>
                      </div>
                      @if (memberAdmittedControl.value) {
                        <div class="mt-4">
                          <p-message
                            class="instruction-message"
                            severity="warn"
                            [text]="isPacCommercial ? memberAdmittedCommMsg : memberAdmittedMaMsg"
                          ></p-message>
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (dischargeControls) {
                  <ng-container [formGroup]="dischargeControls">
                    <div class="field">
                      <label class="field-required">Member's Discharge Date:</label>
                      <div class="p-field-value">
                        <p-date-picker
                          formControlName="memberDischargeDate"
                          placeholder="mm/dd/yyyy"
                          appendTo="body"
                          data-test-id="discharge-date-calendar"
                          [readonlyInput]="true"
                          [showIcon]="true"
                          [minDate]="memberPastDischargeDate"
                          [maxDate]="memberFutureDischargeDate"
                          >
                        </p-date-picker>
                        <errors-messages [control]="dischargeControls.get('memberDischargeDate')"></errors-messages>
                        @if (!isInternalFlow) {
                          <div class="mt-4">
                            <p-message
                              class="instruction-message"
                              severity="warn"
                              [text]="memberDischargeDateMsg"
                            ></p-message>
                          </div>
                        }
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-required">Discharge Disposition:</label>
                      <div class="p-field-value">
                        <p-select
                          placeholder="Select"
                          formControlName="dischargeDisposition"
                          data-test-id="discharge-disposition-dropdown"
                          [options]="references.dischargeDisposition"
                        ></p-select>
                        <errors-messages [control]="dischargeControls.get('dischargeDisposition')"></errors-messages>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-required">Discharge Rationale:</label>
                      <div class="p-field-value">
                        <p-select
                          placeholder="Select"
                          formControlName="dischargeRationale"
                          data-test-id="discharge-rationale-dropdown"
                          [options]="references.dischargeRationale"
                        ></p-select>
                        <errors-messages [control]="dischargeControls.get('dischargeRationale')"></errors-messages>
                      </div>
                    </div>
                  </ng-container>
                }
                <div class="field" [class.p-disabled]="form.get('urgency').disabled">
                  <label [class.field-required]="isInternalFlow">Urgency:</label>
                  <div class="p-field-value">
                    <p-select
                      placeholder="Select"
                      formControlName="urgency"
                      data-test-id="urgency-dropdown"
                      [options]="references.urgency"
                      (onChange)="onUrgencyChange()"
                    ></p-select>
                    <errors-messages [control]="form.get('urgency')"></errors-messages>
                  </div>
                </div>
                @if (isInternalFlow) {
                  <div class="field" [class.p-disabled]="form.get('requestSource').disabled">
                    <label class="field-required">Request Source:</label>
                    <div class="p-field-value">
                      <p-select
                        placeholder="Select"
                        formControlName="requestSource"
                        data-test-id="request-source-dropdown"
                        [options]="references.requestSource"
                      ></p-select>
                      <errors-messages [control]="form.get('requestSource')"></errors-messages>
                    </div>
                  </div>
                  <div class="field" [class.p-disabled]="form.get('requestor').disabled">
                    <label class="field-required">Requestor:</label>
                    <div class="p-field-value">
                      <p-select
                        placeholder="Select"
                        formControlName="requestor"
                        data-test-id="requestor-dropdown"
                        [options]="references.requestor"
                      ></p-select>
                      <errors-messages [control]="form.get('requestor')"></errors-messages>
                    </div>
                  </div>
                  @if (form.get('memberRepresentative')) {
                    <div class="field">
                      <label class="field-required">Member Representative:</label>
                      <div class="p-field-value">
                        <input
                          type="text"
                          pInputText
                          trimInputValue
                          formControlName="memberRepresentative"
                          data-test-id="member-representative-input"
                          />
                          <errors-messages
                            [class.hidden]="!form.get('memberRepresentative').errors || form.get('memberRepresentative').hasError('required')"
                            [control]="form.get('memberRepresentative')"
                          ></errors-messages>
                          <div class="mt-4">
                            <p-message
                              class="instruction-message"
                              severity="warn"
                              [text]="memberRepresentativeMsg"
                            ></p-message>
                          </div>
                        </div>
                      </div>
                    }
                  }
                </div>
              </div>
            </form>
  } @else {
    <p-progressSpinner></p-progressSpinner>
  }
</p-panel>

<div class="flex justify-between pt-6">
  <div>
    <button
      pButton
      severity="danger"
      aria-label="Cancel Create Authorization"
      label="Cancel"
      icon="pi pi-times"
      type="button"
      data-test-id="cancel-request-button"
      (click)="onCancel()"
    ></button>
  </div>
  <div>
    <button
      pButton
      aria-label="Next Step to Diagnosis"
      label="Next"
      icon="pi pi-arrow-right"
      iconPos="right"
      type="button"
      data-test-id="next-step-button"
      [disabled]="!form?.valid"
      [loading]="checkingForIncompleteAuth || isNextLoading"
      (click)="onSubmit()"
    ></button>
  </div>
</div>

<p-dialog
  header="Do you have the supporting physician's order available?"
  [style]="{ width: '32rem' }"
  [modal]="true"
  [closable]="true"
  [(visible)]="dialogVisible"
  >
  <div class="mb-2">
    <i>
      {{ isPacCommercial
      ? "To mark the request as urgent, it is required to upload a supporting Physician's Order with associated clinical documentation."
      : "Supporting physician's order is required to meet the CMS definition of an urgent request and must be uploaded where applicable."
      }}
    </i>
  </div>
  <div class="flex gap-4">
    <div class="flex items-center">
      <p-radio-button
        name="supportingPhysicianAvailable"
        inputId="supportingPhysician_yes"
        class="mr-2"
        data-test-id="supporting-physician-available-radioButton"
        [value]="true"
        [(ngModel)]="supportingPhysicianAvailable"
      />
      <label for="supportingPhysician_yes" class="ml-2">Yes</label>
    </div>
    <div class="flex items-center">
      <p-radio-button
        name="supportingPhysicianAvailable"
        inputId="supportingPhysician_no"
        data-test-id="no-supporting-physician-available-radioButton"
        [value]="false"
        [(ngModel)]="supportingPhysicianAvailable"
      />
      <label for="supportingPhysician_no" class="ml-2">No</label>
    </div>
  </div>
  @if (!supportingPhysicianAvailable) {
    <div class="mt-2">
      Without the supporting physician order, this request does not meet the CMS definition for urgent. In order to be compliant with CMS, please update the Urgency field to Routine.
    </div>
  }
  <ng-template pTemplate="footer">
    @if (!supportingPhysicianAvailable) {
      <button
        pButton
        type="button"
        class="p-button-secondary"
        data-test-id="urgency-back-button"
        (click)="dialogVisible = false"
        >
        Back
      </button>
    } @else {
      @if (supportingPhysicianAvailable) {
        <button
          pButton
          type="button"
          label="Continue"
          icon="pi pi-arrow-right"
          iconPos="right"
          data-test-id="urgency-continue-button"
          (click)="dialogVisible = false"
          >
        </button>
      }
    }
  </ng-template>
</p-dialog>
